var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed inset-0 bg-main-400 w-full h-full z-40 background"},[_c('div',{staticClass:"w-full bg-main300 h-2"},[_c('div',{staticClass:"h-full bg-white rounded-r",style:({width:_vm.percentage + '%'})})])])}
var staticRenderFns = []

export { render, staticRenderFns }